<template>
  <div class="page contract__page" :class="{ 'page__has-bar': showSignBar }">
    <div class="page__hd">
      <h1 class="page__title">{{ form.main.co_title }}</h1>
      <p class="page__desc">
        <span v-format="'yyyy-MM-dd'">{{ form.main.co_date }}</span>
        &nbsp;{{ form.main.creatorName }}
      </p>
    </div>
    <div class="page__bd" v-if="form.main.co_content" v-html="form.main.co_content"></div>
    <iframe class="iframe" v-else :src="getContractUrl()" frameborder="0"></iframe>
    <div class="footer-bar weui-dialog__ft" v-if="showSignBar">
      <div class="sign-info" v-if="signInfo.signPath">
        <div class="weui-msg__image-box" :style="fileBoxStyle"></div>
      </div>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="sign"
        >签名</a
      >
    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";
import Auth from "@/util/auth.js";
import { getBaseUrl } from '@/util/env';

const printUrl = process.env.VUE_APP_PRINT_URL || '';
let routeParamSignInfo;
export default {
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/oa/contract",
      showSignBar: false,
      signInfo: {
        signPath: null,
      },
    };
  },
  computed: {
    fileBoxStyle() {
      var url = this.signInfo.signPath;
      if (url) {
        return (
          'background-image: url("' +
          getBaseUrl() +
          "/api/file/download?path=" +
          url +
          '");'
        );
      }
      return "";
    },
  },
  beforeRouteEnter(to, from, next) {
    // 从签名面板返回的数据
    routeParamSignInfo = from.params.signInfo;
    next();
  },
  mounted() {
    var me = this;
    if (routeParamSignInfo) {
      me.signInfo = routeParamSignInfo;
    } else {
      me.signInfo = { signPath: null };
    }
  },
  methods: {
    f_afterload(form) {
      var me = this,
        main = form.main,
        signItems = form.items;
      if (!signItems) {
        return;
      }
      if (main.co_statuscode != "AUDITED") {
        return;
      }
      // 判断是否需要签名
      Auth.get().then(function (data) {
        var account = data.account,
          item;
        if (account) {
          item = signItems.find((i) => i.cs_userid == account.id);
          me.showSignBar = item && item.cs_status == "未签署";
          if (me.showSignBar) {
            if (routeParamSignInfo && me.signInfo.signPath) {
              me.doSign();
            } 
            // else {
            //   me.getAccountSign();
            // }
          }
        }
      });
    },
    getContractUrl() {
      let {co_platform_url, bizType, bizId} = this.form.main
      if(co_platform_url) {
        let param = 'bizId=' + bizId,
            url = printUrl + '/auth?page=' + encodeURIComponent(`/preview?bizType=${bizType}&${param}`,);

        url += '&token=' + co_platform_url;
        return url;
      } else {
        return null
      }
    },
    /**
     * 签名
     */
    sign() {
      var me = this;
      // if (me.signInfo.signPath) {
      //   me.doSign();
      // } else {
        me.$router.push({
          name: "SignPad",
        });
     // }
    },
    doSign() {
      var me = this,
        id = me.form.main.id;
      me.$loading({
        url: "/api/oa/contract/signContract/" + id,
        method: "POST",
      }).then(function (res) {
        if (res.success) {
          me.$weui.toast("签名成功", 2000);
          me.showSignBar = false;
        } else {
          me.$weui.topTips(res.message, 3000);
        }
      });
    },
    /**
     * 展示电子签名
     */
    getAccountSign() {
      var me = this;
      me.$loading({
        url: "/api/account/sign",
      }).then(function (res) {
        if (res.success) {
          // me.signInfo = res.data || { signPath: null };
          me.signInfo = {
            signPath: null,
          };
        }
      });
    },
  },
};
</script>

<style>
.contract__page {
  background: #fff;
}
.contract__page .page__hd {
  padding: 20px;
  text-align: center;
}
.contract__page .page__title {
  font-weight: normal;
}
.contract__page .page__desc {
  color: #888;
}
.contract__page .page__bd {
  padding: 0 20px;
  background: #fff;
}
.contract__page.page__has-bar .page__bd {
  padding: 0 20px 48px 20px;
}
.contract__page .sign-info {
  flex: 2;
}
.contract__page .weui-msg__image-box {
  width: 100%;
  max-width: 180px;
  height: 100%;
  max-height: 56px;
  margin: 0 auto;
  background-position: 0% 0%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.iframe {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 600px;
  overflow-x: scroll;
}
</style>